import React from 'react';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8 font-sans flex-1 text-gray-800">
      <div className="max-w-3xl mx-auto p-8 sm:p-12">
        <h1 className="text-3xl font-bold mb-6 text-gray-900 tracking-tight">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8 font-medium">Last updated: {new Date().toLocaleDateString()}</p>
        
        <div className="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">1. Information We Collect</h2>
            <p>Welcome to our Privacy Policy. This policy describes how we collect, use, and handle your information when you use our services, including our integration with third-party platforms like Instagram and WhatsApp.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">2. Information We Collect</h2>
            <p>When you interact with our platform through messaging apps (like Instagram Direct Messages or WhatsApp), we may collect the following information:</p>
            <ul className="list-disc pl-5 mt-3 space-y-2 text-gray-700">
              <li>Your basic public profile information (such as your username or name).</li>
              <li>The content of the messages you send to connected business accounts.</li>
              <li>Timestamp and metadata associated with your messages to facilitate our automated AI responses.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">2. How We Use Your Information</h2>
            <p>
              The information we collect is used in the following ways:
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-2 text-gray-700">
              <li>To provide, operate, and maintain our services.</li>
              <li>To improve, personalize, and expand our services.</li>
              <li>To understand and analyze how you use our services.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">4. Data Sharing and Disclosure</h2>
            <p>We do not sell your personal data. We only share information with third-party service providers (like OpenAI for AI processing) strictly necessary to provide the service. These providers are bound by strict data processing agreements.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">5. Data Retention and Deletion</h2>
            <p>We retain your data only for as long as necessary to provide our services. You have the right to request the deletion of your data at any time. Please refer to our Data Deletion Instructions for more details.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">3. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at: <a href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL || 'contacto@taratic.com'}`} className="text-blue-700 hover:text-blue-800 underline underline-offset-2 font-medium">{import.meta.env.VITE_SUPPORT_EMAIL || 'contacto@taratic.com'}</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
